import React from 'react';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function BannerItem({ banner }) {
  const { trans, currentLanguage } = useTranslation();
  return (
    <div className="relative h-full w-full flex items-center justify-center bg-black">
      <img src={banner?.[`banner_image_path_${currentLanguage}`] || banner?.banner_image_path_ka} alt={`${banner[`title_${currentLanguage}`]}`} width="100%" height="100%" className="absolute object-cover" />
      <div className="h-screen pt-[150px] lg:h-auto lg:pt-0 container lg:px-[95px] flex flex-col gap-4 z-10 banner-description">
        <h2 className="text-white text-4xl m-0">{banner[`title_${currentLanguage}`]}</h2>
        <p className="text-white text-base m-0 hidden lg:block">{banner[`subtitle_${currentLanguage}`]}</p>
        {(banner?.[`link_${currentLanguage}`] || banner?.link_ka) && (
        <a
          href={banner?.[`link_${currentLanguage}`] || banner?.link_ka}
          className="text-white text-base hover:underline underline w-fit hover:text-white"
        >
          {trans('see_more')}
        </a>
        )}
      </div>
    </div>
  );
}

export default BannerItem;
